import * as React from 'react';
import { ExtensionSlot, defaultRender } from 'piral-core';
export const DefaultContainer = (props) => (React.createElement(ExtensionSlot, { name: "dashboard", params: props, empty: () => defaultRender(props.children, 'default_dashboard') }));
export const DefaultTile = (props) => defaultRender(props.children);
//# sourceMappingURL=default.js.map